export default __webpack_public_path__ + "./images/sh.da380c02.png";